
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { CallCandidateRequest, CallCandidateResponse } from '@/utils/a2a/types/schedulerTypes';
import { toast } from 'sonner';

export const useSchedulerCalls = () => {
  const [callStatus, setCallStatus] = useState<'idle' | 'initiating' | 'in-progress' | 'completed' | 'failed'>('idle');

  const callCandidate = async (request: CallCandidateRequest): Promise<CallCandidateResponse | null> => {
    try {
      setCallStatus('initiating');

      const { data, error } = await supabase.functions.invoke('scheduling/call-candidate', {
        body: JSON.stringify(request)
      });

      if (error) throw error;
      setCallStatus('in-progress');

      return data;
    } catch (error) {
      console.error('Error calling candidate:', error);
      setCallStatus('failed');
      toast.error('Failed to call candidate');
      return null;
    }
  };

  return {
    callStatus,
    callCandidate
  };
};
